import { useEffect } from 'react';

import useAlert from '@/hooks/useAlert';
import { getQueryParam } from '@/utils/queryParams';

const useSignUpFlashMessage = () => {
  const { setErrorAlert } = useAlert();
  const flashKey = getQueryParam('flash');

  useEffect(() => {
    switch (flashKey) {
      case 'no-saml-sign-up':
        setErrorAlert('No SSO sign up is in progress.');
        break;
      case 'no-saml-app':
        setErrorAlert('SSO is not enabled for the organization.');
        break;
      default:
        break;
    }
  }, [flashKey, setErrorAlert]);
};

export default useSignUpFlashMessage;
